import { render, staticRenderFns } from "./DataUploader.vue?vue&type=template&id=603a0bd8&"
import script from "./DataUploader.vue?vue&type=script&lang=js&"
export * from "./DataUploader.vue?vue&type=script&lang=js&"
import style0 from "./DataUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports